import { render, staticRenderFns } from "./posts.vue?vue&type=template&id=4469e49e&"
import script from "./posts.vue?vue&type=script&lang=js&"
export * from "./posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../themes/chop-child/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/proservdemo25/public_html/wp-content/themes/chop-child/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4469e49e')) {
      api.createRecord('4469e49e', component.options)
    } else {
      api.reload('4469e49e', component.options)
    }
    module.hot.accept("./posts.vue?vue&type=template&id=4469e49e&", function () {
      api.rerender('4469e49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "plugins/MtcPostFilter/assets/components/posts.vue"
export default component.exports